import { Component, OnInit, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { EnquiryPopupComponent } from "../../../popup/enquiry-popup/enquiry-popup.component";
import { GET_NCD_CONFIRMATION } from "@store/sat-motor/sat-motor.action";
import { SortEvent, SortDirection } from '@aposin/ng-aquila/table/public-api';
import { NX_DATE_FORMATS } from "@aposin/ng-aquila/datefield";
import { NxMomentDateModule } from "@aposin/ng-aquila/moment-date-adapter";
import { ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';
import { debounceTime, Subject, takeUntil } from 'rxjs';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: 'app-ncd-confirmation',
  standalone: true,
  imports: [
    SharedModule,
    NxMomentDateModule
  ],
  providers: [{ provide: NX_DATE_FORMATS, useValue: MY_FORMATS }],
  templateUrl: './ncd-confirmation.component.html',
  styleUrl: './ncd-confirmation.component.scss'
})
export class NcdConfirmationComponent implements OnInit {
  componentDialogRef1?: NxModalRef<EnquiryPopupComponent>;
  jpjIsmForm: FormGroup;
  enquiryDetail: any;
  searchNcdConfirmationForm: FormGroup;
  formattedCurrentDate: any;
  firstDateOfMonth: any;
  endDateOfMonth: any;
  
  searchResult: any = [];
  page: number = 1;
  perPage: number = 10;
  itemsPerPageSelections = [10, 20, 50, 100];
  showPagination: boolean = false;
  searchPerformed: boolean = false;

  unsubscribe$ = new Subject();
  pageFilterForm: FormGroup;

  @ViewChild("templateEnHistory") templateRef5!: TemplateRef<any>;

  templateDialogRef?: NxModalRef<any>;
  @ViewChild("templateOne") templateRef!: TemplateRef<any>;
  showRef(template: TemplateRef<any>, type: any) {
    this.templateRef! = template;
    this.title = type;
  }

  title = "Private Cars Excluding Goods";
  requestTypeList = [
    { code: '- All -', name: 'ALL' },
    { code: 'CCN', name: 'CANCELLATION OF CONFIRMED NO CLAIM DISCOUNT' },
    { code: 'CFN', name: 'NO CLAIM DISCOUNT CONFIRMATION (NEWLY REGISTERED CAR)' },
    { code: 'CFO', name: 'NO CLAIM DISCOUNT CONFIRMATION (REGISTERED CAR)' },
    { code: 'ENQ', name: 'NO CLAIM DISCOUNT ENQUIRY' }
  ];

  constructor(
    private dialogService: NxDialogService,
    public store: Store,
    private router: Router,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {

    this.searchPerformed = false;

    this.setDefaultDate();
    this.searchNcdConfirmationForm = this.fb.group({
      cnoteNo: [''],
      requestType: ['- All -', Validators.required],
      previousVehicleNo: [''],
      currentVehicleNo: [''],
      startDate: [this.firstDateOfMonth, Validators.required],
      endDate: [this.endDateOfMonth, Validators.required]
    }
    );

    this.searchNcdConfirmationForm.get('endDate')?.setValidators([
      Validators.required, this.validateRequestDates
    ]);

    this.searchNcdConfirmationForm.get('startDate')?.setValidators([
      Validators.required, this.validateStartDate
    ]);

    this.pageFilterForm = this.fb.group({
      perPage: [this.perPage]
    });

    this.searchNcdConfirmationForm.get('startDate')?.valueChanges.subscribe((date) => {
      if (date) {
        this.getEndDateOfMonth(new Date(date));

        this.searchNcdConfirmationForm.patchValue({
          endDate: this.endDateOfMonth
        });
      }
    });
  }

  prevPage() {
    this.page--;
  }

  nextPage() {
    this.page++;
  }

  goToPage(n: number) {
    this.page = n;
  }

  setItemPerPage() {
    this.pageFilterForm
      .get("perPage")
      .valueChanges.pipe(debounceTime(250), takeUntil(this.unsubscribe$))
      .subscribe((value) => {
        this.perPage = value;
        this.page = 1;
      });
  }

  onSearchClicked() {

    this.showPagination = false;
    this.searchResult = [];

    let value = {
      "cnoteNo": this.searchNcdConfirmationForm.getRawValue()["cnoteNo"],
      "requestType": this.searchNcdConfirmationForm.getRawValue()["requestType"],
      "previousVehicleNo": this.searchNcdConfirmationForm.getRawValue()["previousVehicleNo"],
      "currentVehicleNo": this.searchNcdConfirmationForm.getRawValue()["currentVehicleNo"],
      "startDate": this.searchNcdConfirmationForm.controls["startDate"].value,
      "endDate": this.searchNcdConfirmationForm.controls["endDate"].value
    };

    console.log('Form values:', this.searchNcdConfirmationForm.getRawValue());
    if (this.searchNcdConfirmationForm.valid) {
      this.store.dispatch(new GET_NCD_CONFIRMATION({ value })).subscribe((res) => {
        this.searchResult = res.SatMotorState.ncdDetails;
        this.searchPerformed = true;
        this.setItemPerPage();
        if (this.searchResult && this.searchResult.length > 10) {
          this.showPagination = true;
        }
      });
    } else {
      this.searchNcdConfirmationForm.markAllAsTouched();
    }

  }

  get paginatedResults() {
    if (this.searchResult) {
      const startIndex = (this.page - 1) * this.perPage;
      return this.searchResult.slice(startIndex, startIndex + this.perPage);
    }
    return [];
  }

  getResultLength() {
    if (this.searchResult) {
      return this.searchResult.length;
    }
    return 0;
  }

  resetForm() {
    this.setDefaultDate();
    this.searchNcdConfirmationForm = this.fb.group({
      cnoteNo: [''],
      requestType: ['- All -', Validators.required],
      previousVehicleNo: [''],
      currentVehicleNo: [''],
      startDate: [this.firstDateOfMonth, Validators.required],
      endDate: [this.endDateOfMonth, Validators.required]
    });

    this.searchNcdConfirmationForm.get('endDate')?.setValidators([
      Validators.required, this.validateRequestDates
    ]);

    this.searchResult = [];
    this.searchPerformed = false;
  }

  setDefaultDate() {
    const currentDate = new Date();
    this.formattedCurrentDate = currentDate.toISOString().split('T')[0]; // 'yyyy-MM-dd'  
    currentDate.setDate(1);
    this.firstDateOfMonth = currentDate.toISOString().split('T')[0];
    this.getEndDateOfMonth(currentDate);
  }

  getRequestTypeName(code: any) {
    return this.requestTypeList.find(rt => rt.code === (code || ''))?.name || '-';
  }

  sortTable(sort: SortEvent) {
    this.searchResult = this.searchResult.slice().sort((a, b) => {
      if (sort.active in a && sort.active in b) {
        if (sort.active != 'updatedDate') {
          return this.compare(a[sort.active], b[sort.active], sort.direction);
        }
        else {
          return this.compareMoment(a[sort.active], b[sort.active], sort.direction);
        }
      }
      return 0;
    });
  }

  compareMoment(
    a: number | string | Date,
    b: number | string | Date,
    direction: SortDirection) {
    return (moment(a).isBefore(b) ? -1 : 1) * (direction === 'asc' ? 1 : -1);
  }

  compare(
    a: number | string | Date,
    b: number | string | Date,
    direction: SortDirection) {
    return (a < b ? -1 : 1) * (direction === 'asc' ? 1 : -1);
  }

  getEndDateOfMonth(startDate: Date) {
    if (!startDate) return; // Prevent errors if startDate is null

    let lastDay = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);

    // Format to 'YYYY-MM-DD' using local time to avoid UTC shift
    let year = lastDay.getFullYear();
    let month = String(lastDay.getMonth() + 1).padStart(2, '0');
    let day = String(lastDay.getDate()).padStart(2, '0');

    this.endDateOfMonth = `${year}-${month}-${day}`;
  }


  // Custom Validator: Ensures End Date is not before Start Date
  validateRequestDates: ValidatorFn = (): ValidationErrors | null => {
    if (this.searchNcdConfirmationForm) {
      const fromDate = this.searchNcdConfirmationForm.get('startDate')?.value;
      const toDate = this.searchNcdConfirmationForm.get('endDate')?.value;

      //End Date is before Start Date
      if (fromDate && toDate) {
        const start = new Date(fromDate);
        const end = new Date(toDate);

        if (end < start) {
          return { endDateBeforeStartDate: true }; // Error: End Date is before Start Date
        }

        //End Date is more than 1 month after Start Date
        const maxEndDate = new Date(start);
        maxEndDate.setMonth(maxEndDate.getMonth() + 1); // Add 1 month

        if (end > maxEndDate) {
          return { endDateTooFar: true };
        }
      }
    }

    return null;
  };

  validateStartDate: ValidatorFn = (): ValidationErrors | null => {
    if (this.searchNcdConfirmationForm) {
      const startDate = this.searchNcdConfirmationForm.get('startDate')?.value; 
  
      if (startDate) {
        const start = new Date(startDate);
        const today = new Date();
  
        // Check if the start date is greater than today's date
        if (start > today) {
          return { startDateInFuture: true };
        } 
      }
    }
  
    return null;
  };
  

  checkDisabled() {
    if (this.searchNcdConfirmationForm.valid) {
      return false;
    } else {
      return true;
    }
  }
}
